import { useMemo, useState } from 'react';
import CodeBlock from './CodeBlock';
import { LANGUAGES } from '@/lib/openapi/snippet';
import { useApiKey } from '@/stores/apiKey.store';

interface Props {
    method: string;
    path: string;
    sampleBody?: unknown;
}

export default function CodeSamples({ method, path, sampleBody }: Props) {
    const [active, setActive] = useState<string>('curl');
    const { key } = useApiKey();

    const lang = LANGUAGES.find((l) => l.id === active) || LANGUAGES[0];
    const code = useMemo(() => lang.fn({ method, path, apiKey: key || undefined, sampleBody }), [lang, method, path, key, sampleBody]);

    return (
        <div>
            <div className="flex items-center gap-1 mb-2 px-1">
                {LANGUAGES.map((l) => (
                    <button
                        key={l.id}
                        onClick={() => setActive(l.id)}
                        className={`text-xxs font-semibold px-2 py-1 rounded transition-colors ${active === l.id ? 'text-ink' : 'text-ghost hover:text-muted'}`}
                        style={active === l.id ? { backgroundColor: 'var(--surface-hover)' } : undefined}
                    >
                        {l.label}
                    </button>
                ))}
            </div>
            <CodeBlock code={code} lang={lang.shikiLang} />
        </div>
    );
}
